export default "__VITE_ASSET__BUuJkDsN__"